module.exports = __webpack_public_path__ + "img/ZG81_06.c568bc97.jpg";